module.exports = __webpack_public_path__ + "img/blog-3-pic-2.fd7f772e.jpg";